<ion-content>
  <form [formGroup]="signatureForm">
    <ion-grid>
      <ion-row class="ion-align-items-center ion-justify-content-start" s-height-100vh>
        <ion-col>
          <ion-row class="ion-align-items-center ion-justify-content-start" max-width-form>
            <ion-col size="12">
              <h1 class="title ion-text-center"> {{'SIGNATURE.SIGNING_REPORT' | translate}} </h1>
              <h3 class="title ion-text-center"> {{'SIGNATURE.ENTER_YOUR_CPF_TO_SIGN' | translate}} </h3>
            </ion-col>
            <ion-col size="12">
              <ion-label position="stacked">{{'SIGNATURE.NAME' | translate}}</ion-label>
              <ion-input
                type="text"
                formControlName="witnessSignatureName"
                placeholder="{{'SIGNATURE.ENTER_THE_NAME' | translate}}"
              >
              </ion-input>
              <ion-note
                color="danger"
                *ngIf="witnessSignatureName.dirty && witnessSignatureName.errors?.required"
              >
                {{'SIGNATURE.INSERT_THE_NAME' | translate}}
              </ion-note>
              <ion-note
                color="danger"
                *ngIf="witnessSignatureName.dirty && !witnessSignatureName.errors?.required && witnessSignatureName.errors?.maxlength"
              >
                {{'SIGNATURE.THE_NAME_MUST_CONTAIN_AT_MOST' | translate}} {{
                witnessSignatureName.errors.maxlength.requiredLength }} {{'SIGNATURE.CHARACTERS' | translate}}
              </ion-note>
            </ion-col>

            <ion-col size="12">
              <ion-label position="stacked">{{'SIGNATURE.CPF' | translate}}</ion-label>
              <ion-input
                type="tel"
                formControlName="witnessSinatureCpf"
                placeholder="{{'SIGNATURE.ENTER_THE_CPF' | translate}}"
                mask="cpf"
                dropSpecialCharacters
              >
              </ion-input>
              <ion-note
                color="danger"
                *ngIf="witnessSinatureCpf.dirty && witnessSinatureCpf.errors?.required"
              >
                {{'SIGNATURE.INSERT_THE_CPF' | translate}}
              </ion-note>
              <ion-note
                color="danger"
                *ngIf="witnessSinatureCpf.dirty && !witnessSinatureCpf.errors?.required && witnessSinatureCpf.errors?.invalidCPF"
              >
                {{'SIGNATURE.INVALID_CPF' | translate}}
              </ion-note>
            </ion-col>

            <ion-col size="12">
              <ion-label position="stacked">{{'SIGNATURE.DATE_OF_BIRTH' | translate}}</ion-label>

              <app-calendar-input
                [control]="signatureForm.get('witnessSignatureBirthday')"
                [maxDate]="maxDate"
              >
              </app-calendar-input>

              <ion-note color="danger" *ngIf="formSubmitted && witnessSignatureBirthday.errors?.required">
                {{'SIGNATURE.INSERT_THE_DATE_OF_BIRTH' | translate}}
              </ion-note>

              <ion-note color="danger" *ngIf="formSubmitted && witnessSignatureBirthday.errors?.maxDate">
                {{'SIGNATURE.DATE_MUST_BE_BEFORE' | translate}} {{ maxDate | date:'dd/MM/yyyy' }}
              </ion-note>

              <ion-note color="danger" *ngIf="formSubmitted && witnessSignatureBirthday.errors?.invalidDate">
                {{'SIGNATURE.INVALID_DATE' | translate}}
              </ion-note>
            </ion-col>

            <ion-col size="6" class="ion-margin-top">
              <ion-button expand="block" fill="outline" color="primary" (click)="download()">
                {{'SIGNATURE.TO_VIEW_REPORT' | translate}}
              </ion-button>
            </ion-col>
            <ion-col size="6" class="ion-margin-top">
              <ion-button expand="block" color="primary" (click)="next(signatureForm)">
                {{'SIGNATURE.TO_SIGN' | translate}}
              </ion-button>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ion-grid>
  </form>

  <ng-template #Loading>
    <div class="ion-justify-content-center ion-padding">
      <ion-spinner color="primary"></ion-spinner>
    </div>
  </ng-template>
</ion-content>
